

























































































































































































































































































import { Component, Prop, Vue } from "@/shared/vuepack";
import {
  HsabPayee,
  LobAddressValidationResponse,
  LobAddressValidationResult,
  LobAutoCompleteAddressRequest,
  SelectorState
} from "@/shared/types";
import { usePayeeStore } from "@/employer/store/payee";
import _ from "lodash";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { getLobSuggestions, lobAddressVerification } from "@/shared/api/userService";
import { useNotifierStore } from "@/shared/store/notifier";
import UsStateSelector from "@/shared/components/UsStateSelector.vue";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";

@Component({
  components: { UsStateSelector, GenericLoadingSpinner }
})
export default class PayeeSelector extends Vue {
  lobAddressValidationResult = LobAddressValidationResult;
  payeeStore = usePayeeStore();
  featureFlagStore = useFeatureFlagStore();
  notifierStore = useNotifierStore();
  hsabExpenseFormStore = useHsabExpenseFormStore();

  @Prop({default: null})
  initialPayee: HsabPayee;
  @Prop()
  readonly: boolean;
  @Prop()
  value: HsabPayee;

  payeeInformationNotSaved = false;
  accountNumberNotAvailable = false;
  searchTerm = "";
  editingPayee: HsabPayee = {...this.blankPayee};
  showSuggestion = false;
  suggestions = [];
  useSuggestion = "";
  itemToDelete: HsabPayee = null;
  lobSuggestion: LobAddressValidationResponse = {
    isValid: false,
    result: LobAddressValidationResult.None,
    validationFootnotes: null,
    suggestedAddress: { addressLine1: "",
    addressLine2: "", zip: "", city: "", state: "" }
  };
  providedAddress: any = {};
  debouncedSearchFunction = _.debounce(newText => this.getAddress(newText), 600);

  get blankPayee (): HsabPayee {
    return {
      payeeId: null,
      payeeName: "",
      memberAccountNumber: "",
      address1: "",
      address2: "",
      city: "",
      stateCode: "",
      zip: ""
    };
  }

  get showSearch () {
    return !this.payeeStore.isFetchingLoading && this.hsabExpenseFormStore.currentPayeeSelectorState === SelectorState.Searching;
  }
  get showCreate () {
    return !this.payeeStore.isFetchingLoading && this.hsabExpenseFormStore.currentPayeeSelectorState === SelectorState.Creating;
  }

  get showEdit () {
    return !this.payeeStore.isFetchingLoading && this.hsabExpenseFormStore.currentPayeeSelectorState === SelectorState.Editing;
  }

  get showSelectedPayee () {
    return !this.payeeStore.isFetchingLoading &&
        this.hsabExpenseFormStore.selectedPayee &&
        this.hsabExpenseFormStore.currentPayeeSelectorState === SelectorState.Selected;
  }

  get showEditButtonOverride () {
    return this.hsabExpenseFormStore.currentPayeeSelectorState === SelectorState.Selected &&
        this.hsabExpenseFormStore.expenseForm.isPayToPayee &&
        this.hsabExpenseFormStore.hasExpense;
  }

  get showEditButton () {
    return this.hsabExpenseFormStore.currentPayeeSelectorState === SelectorState.Selected &&
        this.hsabExpenseFormStore.selectedPayee &&
        this.hsabExpenseFormStore.selectedPayee.payeeId &&
        this.hsabExpenseFormStore.selectedPayee.payeeId > 0 &&
        !this.readonly;
  }

  get showClearButton () {
    return this.hsabExpenseFormStore.currentPayeeSelectorState === SelectorState.Selected &&
        this.hsabExpenseFormStore.selectedPayee &&
        !this.readonly;
  }

  get showDeleteConfirmation () {
    return this.hsabExpenseFormStore.currentPayeeSelectorState === SelectorState.DeleteConfirmation
        && this.itemToDelete !== undefined
        && this.itemToDelete !== null;
  }

  get showCreateNewPayeeButton () {
    return this.hsabExpenseFormStore.currentPayeeSelectorState === SelectorState.Searching &&
        !this.readonly;
  }

  get showMainLoader () {
    return this.payeeStore.isFetchingLoading;
  }

  get payeesList (): HsabPayee[] {
    if (this.searchTerm.length > 0) {
      return this.payeeStore.payeesForUser;
    }
    return this.payeeStore.sortedLastActivePayees;
  }
  get useLobApi () {
    return this.featureFlagStore.flags.bend19874ExpensePayeeAddressLob;
  }

  get isActionDisabled () {
    return !this.verifiedAddress && this.showSuggestion && this.useSuggestion === "";
  }

  mounted () {
    const selectedPassedInAsProp = this.initialPayee !== null && this.initialPayee.payeeName;
    if (selectedPassedInAsProp) {
      this.hsabExpenseFormStore.selectedPayee = _.cloneDeep(this.initialPayee);
      this.hsabExpenseFormStore.currentPayeeSelectorState = SelectorState.Selected;
    }
    this.payeeStore.loadLastActivePayeesFromStorage();
    this.payeeStore.loadPayees().then(
        () => {
          if (!selectedPassedInAsProp) {
            this.hsabExpenseFormStore.currentPayeeSelectorState = SelectorState.Searching;
          }
        }
    );
  }

  get suggestedAddress (): any {
    if (this.lobSuggestion && this.lobSuggestion.suggestedAddress) {
      return this.lobSuggestion.suggestedAddress;
    }
    return {};
  }

  verifyAddress (): Promise<any> {
    if (this.verifiedAddress) {
      return Promise.resolve();
    }

    this.providedAddress = {
      address1: this.editingPayee.address1,
      address2: this.editingPayee.address2,
      city: this.editingPayee.city,
      stateCode: this.editingPayee.stateCode,
      zip: this.editingPayee.zip };

    return lobAddressVerification({
        properCase: true,
        address: {
          addressLine1: this.editingPayee.address1,
          addressLine2: this.editingPayee.address2,
          city: this.editingPayee.city,
          state: this.editingPayee.stateCode,
          zip: this.editingPayee.zip
        }
    }).then(response => {
      this.lobSuggestion = response.data;
       if (!response.data.isValid ||
            response.data.result !== LobAddressValidationResult.Confirmed) {
         this.showSuggestion = true;
        return Promise.reject();
      }
      return Promise.resolve();
    });
  }

  onSuggestionRadioChecked (value) {
    this.verifiedAddress = true;
    if (value === "B") {
      this.editingPayee = { ...this.editingPayee,
        address1: this.lobSuggestion.suggestedAddress.addressLine1,
        address2: this.lobSuggestion.suggestedAddress.addressLine2,
        city: this.lobSuggestion.suggestedAddress.city,
        stateCode: this.lobSuggestion.suggestedAddress.state,
        zip: this.lobSuggestion.suggestedAddress.zip };
    }
  }

  onCancelCreateOrEditClicked () {
    this.resetEditingPayee();
    this.$nextTick(function () {
      if (this.hsabExpenseFormStore.selectedPayee && this.hsabExpenseFormStore.selectedPayee.payeeName) {
        this.hsabExpenseFormStore.currentPayeeSelectorState = SelectorState.Selected;
      } else {
        this.hsabExpenseFormStore.currentPayeeSelectorState = SelectorState.Searching;
      }
    });
   this.$emit("is-editing", false);
  }

  onEditSelectedPayeeClicked () {
    this.hsabExpenseFormStore.currentPayeeSelectorState = SelectorState.Editing;
    this.$validator.errors.clear();
    this.editingPayee = _.cloneDeep(this.hsabExpenseFormStore.selectedPayee);
    this.$emit("is-editing", true);
  }

  onEditAddressPayeeClicked () {
    this.hsabExpenseFormStore.currentPayeeSelectorState = SelectorState.Editing;
    this.$validator.errors.clear();
    this.editingPayee = this.getEditingPayee();
    this.$emit("is-editing", true);
    this.showSuggestion = false;
  }

  onCreateNewPayeeClicked () {
    this.hsabExpenseFormStore.currentPayeeSelectorState = SelectorState.Creating;
    this.resetEditingPayee();
    this.$emit("is-editing", true);
  }

  onSaveChangesClicked () {
    this.$validator.errors.clear();
    this.$validator.validateAll().then(valid => {
      if (!valid) {
      return;
    }

    this.verifyAddress().then(_ => {
      if (this.hsabExpenseFormStore.hasExpense) {
        // just update the expense Payee data
        this.payeeInformationNotSaved = true;
        this.$emit("payee-selected", this.editingPayee);
        this.hsabExpenseFormStore.currentPayeeSelectorState = SelectorState.Selected;
        this.$emit("is-editing", false);
        this.resetEditingPayee();
      } else {
        // save to existing Payee data
        return this.payeeStore.savePayee(this.editingPayee).then(p => {
          if (p) {
            this.hsabExpenseFormStore.selectedPayee = p;
            this.$emit("payee-selected", p);
            this.hsabExpenseFormStore.currentPayeeSelectorState = SelectorState.Selected;
            this.$emit("is-editing", false);
            this.resetEditingPayee();
          }
        });
      }
    }).catch(_ => {
      // Error handled by the UI Validation
    });
    });
  }

  onCreatePayeeClicked () {
    this.$validator.errors.clear();
    this.$validator.validateAll().then(valid => {
      if (!valid) {
        return;
      }
      this.verifyAddress().then(_ => {
        return this.payeeStore.createPayee(this.editingPayee).then(p => {
          if (p) {
            this.hsabExpenseFormStore.selectedPayee = p;
            this.$emit("payee-selected", p);
            this.hsabExpenseFormStore.currentPayeeSelectorState = SelectorState.Selected;
            this.$emit("is-editing", false);
            this.payeeStore.setPayeeActivityUpdate(p);
            this.resetEditingPayee();
          }
        });
      }).catch(_ => {
        // Error handled by the UI Validation
      });
    });
  }

  onClearSelectedPayee () {
    this.hsabExpenseFormStore.selectedPayee = null;
    this.hsabExpenseFormStore.currentPayeeSelectorState = SelectorState.Searching;
    this.$emit("payee-selected", null);
  }

  onPayeeSelected (item) {
    this.$emit("input", item);
    this.$emit("payee-selected", item);
    this.searchTerm = "";
    this.hsabExpenseFormStore.currentPayeeSelectorState = SelectorState.Selected;
    this.payeeStore.setPayeeActivityUpdate(item);
  }

  onDeletePayeeClicked (item: HsabPayee) {
    this.itemToDelete = item;
    this.hsabExpenseFormStore.currentPayeeSelectorState = SelectorState.DeleteConfirmation;
  }

  onDeleteCancelled () {
    this.hsabExpenseFormStore.currentPayeeSelectorState = SelectorState.Searching;
  }

  onDeleteConfirmed () {
    this.payeeStore.deletePayee(this.itemToDelete.payeeId).then(
        _ => {
          this.payeeStore.deletePayeeActivityRecord(this.itemToDelete.payeeId);
          this.itemToDelete = null;
          this.hsabExpenseFormStore.currentPayeeSelectorState = SelectorState.Searching;
        }
    );
  }

  getEditingPayee () {
    if (this.hsabExpenseFormStore.selectedPayee) {
      return _.cloneDeep(this.hsabExpenseFormStore.selectedPayee);
    }
    else if  (this.editingPayee) {
      return _.cloneDeep(this.editingPayee);
    }
    else return this.blankPayee;
  }

  resetEditingPayee () {
    this.editingPayee.payeeId = null;
    this.editingPayee.payeeName = this.hsabExpenseFormStore.expenseForm.providerName !== "" ? this.hsabExpenseFormStore.expenseForm.providerName : "";
    this.editingPayee.memberAccountNumber = "";
    this.editingPayee.address1 = "";
    this.editingPayee.address2 = "";
    this.editingPayee.city = "";
    this.editingPayee.stateCode = "";
    this.editingPayee.zip = "";
    this.showSuggestion = false;
    this.lobSuggestion = { isValid: false,
                            result: LobAddressValidationResult.None,
                            validationFootnotes: null,
                            suggestedAddress: { addressLine1: "",
                            addressLine2: "", zip: "", city: "", state: "" }};
    this.useSuggestion = "";
    this.verifiedAddress = false;
    this.providedAddress = {};

    this.$validator.errors.clear();
  }

  formatPayeeAddressLine1And2 (payee: HsabPayee) {
    let result = payee.address1;

    if (payee.address2) {
      result += " " + payee.address2;
    }
    return result;
  }

  formatPayeeAddressCityStateZip (payee: HsabPayee) {
    let result = payee.city;

    if (payee.stateCode || payee.zip) {
      result += ", ";

      result += payee.stateCode;

      if (payee.zip) {
        result += " " + payee.zip;
      }
    }
    return result;
  }

  payeeFormatForSearch (payee) {
    return payee.payeeName;
  }

  async getAddress (newText) {
    this.$emit("input", this.editingPayee);
    if (this.selectingAddress) {
      this.selectingAddress = false;
      return;
    }
    if (newText !== undefined && newText !== "") {
      try {
        const request: LobAutoCompleteAddressRequest = {
          address: newText,
          city: this.editingPayee.city,
          state: this.editingPayee.stateCode,
          zip: this.editingPayee.zip,
          validSuggestions: true,
          properCase: true,
          geoIpSearch: true,
        };
        const res = await getLobSuggestions(request);
        if (res.data.suggestions !== null) {
          this.suggestions = res.data.suggestions.map(
              p => ({ ...p, fullAddress: `${p.addressLine1} ${p.city}, ${p.state} ${p.zip}` })
          );
        }
      } catch (error) {
        this.handleError(error);
      }
    }
  }

  selectingAddress = false;
  verifiedAddress = false;

  addressSelected (selectedAddress) {
    this.selectingAddress = true;
    this.verifiedAddress = true;
    this.editingPayee = {
      ...this.editingPayee,
      address1: selectedAddress.addressLine1,
      city: selectedAddress.city,
      stateCode: selectedAddress.state,
      zip: selectedAddress.zip,
    };

    const typeaheadRef = this.$refs.typeahead as any;
    typeaheadRef.inputValue = this.editingPayee.address1;
  }

  onInput () {
    if (this.useLobApi) {
      this.verifiedAddress = false;
    }
  }
  onPrimaryAddressInput (text) {
    this.verifiedAddress = false;
    this.debouncedSearchFunction(text.trim());
  }
  showError (message: string): void {
    this.notifierStore.setDanger(message);
  }

  handleError (err: any): void {
    this.showError(
        (err && err.errorMessage) ||
        "Error processing your request. Please try again later"
    );
  }
}
